import { useEffect, useState } from "react";
import styled from "styled-components";
import React from "react";
import Product from "./Product";
import axios from "axios";
import { popularProducts } from "../data";

const Container = styled.div`
    padding: 20px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;

const Products = ({cat,filters,sort}) => {
 
 const [products, setProducts] =useState([]) //product state
 const [filteredproducts, setFilteredProducts] =useState([]) //change our filter will updated our filtered
 //use axios =>get and post request
useEffect(() => {   //when cat change the effect change / use get and post request
  const getProducts = async ()=>{
    try{ //use cat to fetching our data  // get 那邊首頁跟category分頁要分開不然會都是篩選的 : no 
      const res = await axios.get(cat 
        ? `http://localhost:5000/api/products?category=${cat}`
        : "http://localhost:5000/api/products?category"
        ) //api url
        //updating set products
        setProducts(res.data)
    }catch(err){
      console.log("err")
    }
  }
  getProducts() //use it
}, [cat])

useEffect(()=>{ 
  // if there is a cat
 cat && setFilteredProducts(
   products.filter(item=>Object.entries(filters).every(([key,value])=>
   item[key].includes(value)
   ))
 )

},[products,cat,filters]) //depend on cat filter
useEffect(()=>{
  if((sort==="最新")){
    setFilteredProducts((prev)=>
      [...prev].sort((a,b)=>a.createdAt -b.createdAt) // a greater than b display the nearest items
      )
  }else if((sort==="最高到最低")){
    setFilteredProducts((prev)=>
      [...prev].sort((a,b)=>a.price -b.price) // a greater than b display the nearest items
      )
  }else if((sort==="最低到最高")){
    setFilteredProducts((prev)=>
      [...prev].sort((a,b)=>b.price -a.price) // a greater than b display the nearest items
      )
  }
},[sort])

  return (
    <>
    <Container>
      
      {/* {cat ? filteredproducts.map((item) => ( //map 分類群點過去會分類 下面那個先讓他消失popularProducts=>filteredproducts
        <Product item={item} key={item.id} /> //if there is a cat use this filtered
      ))   : products.slice(0,16)
      .map((item) => ( 
        <Product item={item} key={item.id} /> ))
       } */}
       {cat ? popularProducts.map((item) => ( //map 分類群點過去會分類 下面那個先讓他消失popularProducts=>filteredproducts
        <Product item={item} key={item.id} /> //if there is a cat use this filtered
      ))   : products.slice(0,4) 
      .map((item) => ( 
        <Product item={item} key={item.id} /> ))
       }
    </Container>
    </>
  );
};

export default Products;
